import { createSlice } from "@reduxjs/toolkit"

export const reqBrandListSlice = createSlice({
	name: "reqBrand_list",
	initialState: {
		reqBrand: "",
		errors: [],
	},

	reducers: {
        getReqBrand: (state, action) => {
            // console.log(action.payload)
			state.reqBrand = action.payload
		},
		getRegBrandList: (state, action) => {
			state.reqBrand = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getReqBrand, getRegBrandList, getErrors} = reqBrandListSlice.actions

export default reqBrandListSlice.reducer
